/**
 * Configuración centralizada de Axios
 * - Interceptores de request/response
 * - Manejo de errores global
 * - Headers de autenticación
 */
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "/";

const apiClient = axios.create({
  baseURL: API_URL,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
  },
});

// Interceptor de Request - Agregar headers de autenticación
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    const userStr = localStorage.getItem("user");

    // Bearer token si existe
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // ❗ NO mandamos x-headers vacíos. Solo si hay data real.
    if (userStr) {
      try {
        const user = JSON.parse(userStr);

        const userId = user?.Legajo || user?.CdEmpleado;
        const userName = user?.Nombre;
        const userRole = user?.IdRol;
        const baseId = user?.base_id;
        const portalRRHH = user?.PortalRRHH;
        const adminLevel = user?.AdminLevel;

        if (userId != null) config.headers["x-user-id"] = String(userId);
        if (userName) config.headers["x-user-name"] = String(userName);
        if (userRole != null) config.headers["x-user-role"] = String(userRole);
        if (baseId != null) config.headers["x-base-id"] = String(baseId);
        if (portalRRHH != null) config.headers["x-portal-rrhh"] = String(portalRRHH);
        if (adminLevel != null) config.headers["x-admin-level"] = String(adminLevel);
      } catch (e) {
        console.error("Error parsing user from localStorage", e);
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor de Response - Manejo de errores global
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error;

    if (response) {
      switch (response.status) {
        case 401:
          // Token expirado o inválido
          localStorage.removeItem("token");
          localStorage.removeItem("user");
          window.location.href = "/";
          break;
        case 403:
          console.error("Sin permisos para esta acción");
          break;
        case 500:
          console.error("Error del servidor");
          break;
        default:
          break;
      }
    }

    return Promise.reject(error);
  }
);

export default apiClient;
